"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASH_EXPENSE_SERIES = void 0;
exports.priceExpense = priceExpense;
exports.cashExpenseIntent = cashExpenseIntent;
const money_1 = require("../money");
const document_rules_1 = require("../posting/document-rules");
/** سلسلة المصروفات النقدية — مستقلة، والصيغة `BLOCKED-ACCOUNTING` كباقى السلاسل. */
exports.CASH_EXPENSE_SERIES = 'EX';
/**
 * مصروف نقدى مباشر بلا فاتورة مورد (إكرامية، انتقالات، مستلزمات صغيرة): كل سطر بمبلغه
 * مقربًا لقرشين، والإجمالى مجموعها. كل المشاكل تُجمع بفهرس سطرها.
 */
function priceExpense(lines) {
    const issues = [];
    if (lines.length === 0) {
        issues.push({ code: 'INVOICE_NO_LINES', message: 'expense must have at least one line' });
    }
    const priced = lines.map((line, lineIndex) => {
        const amount = money_1.Money.of(line.amount).round(2, 'half_up');
        if (!amount.isPositive()) {
            issues.push({ code: 'LINE_NO_AMOUNT', message: 'expense line must be positive', lineIndex });
        }
        return { description: line.description, amount, account: line.account };
    });
    if (issues.length > 0)
        return { ok: false, issues };
    return {
        ok: true,
        value: { lines: priced, total: money_1.Money.sum(priced.map((line) => line.amount)) },
    };
}
/**
 * قيد المصروف النقدى: مدين كل حساب مصروف بمجموع سطوره، دائن النقدية بالإجمالى. لا
 * طرف دائن ولا ذمة — المصروف دُفع لحظته. ضريبة المدخلات عليه تحتاج قاعدة معتمدة
 * ومستندًا ضريبيًا (BLOCKED-TAX)، فلا تُفصل هنا.
 */
function cashExpenseIntent(ctx, input) {
    const byAccount = new Map();
    for (const line of input.expense.lines) {
        byAccount.set(line.account, (byAccount.get(line.account) ?? money_1.Money.zero()).add(line.amount));
    }
    const lines = [...byAccount].map(([account, amount]) => (0, document_rules_1.debitLine)(account, amount, ctx.currency));
    lines.push((0, document_rules_1.creditLine)(input.sourceAccount, input.expense.total, ctx.currency, {
        cashboxId: input.cashboxId ?? null,
    }));
    return {
        companyId: ctx.companyId,
        sourceType: 'expense',
        sourceId: input.sourceId,
        postingDate: input.postingDate,
        idempotencyKey: input.idempotencyKey,
        reference: input.reference ?? null,
        memo: input.memo ?? null,
        createdBy: ctx.createdBy ?? null,
        lines,
    };
}
//# sourceMappingURL=expense.js.map